// extracted by mini-css-extract-plugin
module.exports = {"col_box":"col_box-S2sb-x3r","col_navlist":"col_navlist-2vhYczqS","pa":"pa-3rXKoIIo"};